import { useState } from "react";
import { URL_API } from "../../../../config/default";
import { myHeaders } from "../../../../config/axios";
import { CustomToast } from "../../../../utils/custom-toast";
import { format } from "date-fns";

/* eslint-disable @typescript-eslint/no-explicit-any */
const Bloqued = ({ setForm, form }: any) => {
  const [dateRange, setDateRange] = useState<any>({
    startDate: new Date(),
    endDate: new Date(),
  });

  const onChange = (e: any, value: string | null) => {
    console.log(value);

    switch (e.target.name) {
      case "start_date":
        {
          setDateRange({
            ...dateRange,
            startDate: e.target.value,
          });
        }
        break;
      case "end_date":
        {
          setDateRange({
            ...dateRange,
            endDate: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  const onClick = (e: any, value: any | null) => {
    switch (e.target.name) {
      case "remove":
        {
          delete form.DATES[value.index];
          const dates = form.DATES.filter((i: any) => i! != null);
          setForm({
            ...form,
            DATES: dates,
          });

          let formdata = new FormData();

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/dates/${value.id}`, requestOptions)
            .then(async () => {
              CustomToast({
                status: 200,
                msg: "",
                title: "Fecha eliminada con exito",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "add":
        {
          const start = new Date(dateRange.startDate);
          const end = new Date(dateRange.endDate);
          const dates: any[] = [];

          while (start <= end) {
            // Formatear como YYYY-MM-DD (puedes cambiar el formato si quieres)
            const formatted = start.toISOString().split("T")[0];
            dates.push({ date: formatted });

            // Avanzar un día
            start.setDate(start.getDate() + 1);
          }

          const formdata = new FormData();
          formdata.append("property_id", form.id);
          formdata.append("DATES", JSON.stringify(dates));

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/dates`, requestOptions)
            .then(async (response) => {
              const datesResults = await response.json();
              setForm({
                ...form,
                DATES: [...form.DATES, ...datesResults.data],
              });
              CustomToast({
                status: 200,
                msg: "",
                title: "Fecha creada con exito",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          Bloquea fechas que no quieres que esten disponibles en tu alojamiento
        </span>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className=" px-2 py-2  border-black rounded-xl">
            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Fecha inicio
              </div>
              <input
                type="date"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 10px 10px" }}
                value={dateRange.start_date}
                name="start_date"
                onChange={(e) => onChange(e, null)}
              />
            </div>
          </div>
          <div className=" px-2 py-2  border-black rounded-xl">
            <div className="relative">
              <div
                className="absolute inset-y-0 start-0 top-[-30px]  flex items-center ps-3 pointer-events-none font-bolder"
                style={{ fontSize: "10px" }}
              >
                Fecha fin
              </div>
              <input
                type="date"
                className="pt-5 w-full"
                style={{ borderRadius: "10px 10px 10px 10px" }}
                value={dateRange.start_date}
                name="end_date"
                onChange={(e) => onChange(e, null)}
              />
            </div>
          </div>

          <div className="px-2 py-2">
            <label
              className="bg-[#8B9456] px-6 py-2 text-white cursor-pointer text-center"
              style={{ borderRadius: "20px" }}
            >
              Aplicar fechas
              <button
                className="hidden"
                name="add"
                onClick={(e) => onClick(e, null)}
              ></button>
            </label>
          </div>
        </div>
      </div>
      <div className="grid lg:grid-cols-4 grid-cols-1">
        {form.DATES
          ? form.DATES.map((date: any, index: number) => {
              return (
                <label
                  className=" bg-white border me-1 mb-2 px-6 py-2 text-black cursor-pointer text-center"
                  style={{ borderRadius: "10px" }}
                  title="Eliminar"
                >
                  {format(new Date(date.date), "dd/MM/yyyy").toString()}
                  <i className="ms-2 bi bi-x-lg"></i>
                  <button
                    className="hidden"
                    name="remove"
                    onClick={(e) => onClick(e, { id: date.id, index: index })}
                  ></button>
                </label>
              );
            })
          : ""}
      </div>
    </div>
  );
};

export default Bloqued;
